import { c as _c } from "react/compiler-runtime";
import type { FC, SVGProps } from "react";
export const HammerIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <title>Hammer Icon</title>;
    t1 = <path d="M21.7704 9.66728L22.2 9.23768C22.5995 8.83816 22.7992 8.6384 22.9192 8.43059C23.2448 7.86666 23.2448 7.17187 22.9192 6.60794C22.7992 6.40013 22.5995 6.20037 22.2 5.80085C21.8004 5.40133 21.6007 5.20157 21.3929 5.08159C20.8289 4.75601 20.1342 4.75601 19.5702 5.08159C19.3624 5.20157 19.1627 5.40133 18.7631 5.80085L18.3335 6.23045M13.1783 18.2593L6.73425 24.7034C6.33473 25.1029 6.13498 25.3027 5.92717 25.4226C5.36324 25.7482 4.66845 25.7482 4.10452 25.4226C3.89671 25.3027 3.69695 25.1029 3.29743 24.7034C2.89791 24.3039 2.69815 24.1041 2.57817 23.8963C2.25259 23.3324 2.25259 22.6376 2.57817 22.0736C2.69815 21.8658 2.89791 21.6661 3.29743 21.2666L9.74147 14.8225M8.88227 13.9633L14.0375 19.1185C16.0627 21.1437 17.0753 22.1563 18.3335 22.1563C19.5918 22.1563 20.6044 21.1437 22.6296 19.1185C24.6547 17.0934 25.6673 16.0808 25.6673 14.8225C25.6673 13.5642 24.6547 12.5517 22.6296 10.5265L17.4743 5.37125C15.4492 3.34608 14.4366 2.3335 13.1783 2.3335C11.92 2.3335 10.9074 3.34608 8.88227 5.37125C6.8571 7.39642 5.84452 8.409 5.84452 9.66728C5.84452 10.9256 6.8571 11.9381 8.88227 13.9633Z" stroke="currentColor" strokeWidth="1.5" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <svg width="1em" height="1em" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};